/**
 * @generated SignedSource<<7e2583cd9b1288749ac425a4e0331c50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaseDataChart_chart$data = {
  readonly info: string | null | undefined;
  readonly level: string | null | undefined;
  readonly levelmax: string | null | undefined;
  readonly leveltext1: string | null | undefined;
  readonly leveltext2: string | null | undefined;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "BaseDataChart_chart";
};
export type BaseDataChart_chart$key = {
  readonly " $data"?: BaseDataChart_chart$data;
  readonly " $fragmentSpreads": FragmentRefs<"BaseDataChart_chart">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BaseDataChart_chart",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "levelmax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leveltext1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leveltext2",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    }
  ],
  "type": "BaseDataChart",
  "abstractKey": null
};

(node as any).hash = "9782c0ef43ab16339bd8e61eb84e6a71";

export default node;
